import React, { Component } from 'react'

import '../../App.css';
import '../styles/TeamMobile.css';

import ContactUsCircle from '../../assets/Contact Us Circle.svg';

import placeholderImage from '../../assets/download.jpeg'; // FOR TESTING PURPOSES ONLY

export default class Team extends Component {

	convertDataToJSX = (data) => {
		let rows = [];

		data.forEach(element => {
			rows.push(
				<div className="row">
					<div className="image">
						<img src={element.picture} />
					</div>

					<div className="name">
						{element.name}
					</div>

					<div className="location">
						{element.location}
					</div>
				</div>
			);
		});

		return rows;
	}

  render() {

		let content = null;
		if (this.props.isLoading) {
			content = <div className="loading-text">Loading...</div>;
		} else {
			content = this.convertDataToJSX(this.props.members);
		}

    return (
      <div className= "mobile-scrollable-flex-container">
			
				<div className="goback-container">
					<div className="goback-button" onClick={this.props.upAction}>
						<img src={ContactUsCircle} className="goback-circle" />
						Go back
          </div>
				</div>

				<div className = "mobile-description-container">
					<div className="text-container">
						{this.props.description}
					</div>
				</div>

        <div className = "mobile-team-container">
					{content}
				</div>

      </div>
    )
  }
}
